export default function SectionHeader({ kicker, title, subtitle, right }) {
  return (
    <div className="flex flex-wrap items-start sm:items-end justify-between gap-3 sm:gap-4 mb-4">
      <div className="min-w-0 flex-1">
        {kicker && <p className="text-xs uppercase tracking-wider text-indigo-600 dark:text-indigo-300 font-semibold">{kicker}</p>}
        {title && <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-100 tracking-tight">{title}</h2>}
        {subtitle && <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">{subtitle}</p>}
      </div>
      {right ? <div className="w-full sm:w-auto min-w-0 max-w-full">{right}</div> : null}
    </div>
  );
}
